module.exports = __webpack_public_path__ + "img/1.45ee19a0.jpg";